import { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { PublicRoutesEnum } from 'src/Router/PublicComponentsNewUI'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'
import { HelmetTitle } from '../../Components/HelmetTitle'
import { CreateCampaignBreadcrumbsNoAuth } from '../../Components/CreateCampaignBreadcrumbsNoAuth'
import { ReleaseTypeItem } from '../../Components/ReleaseTypeItem'

const Container = styled.div`
  display: flex;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const ReleaseTypesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const ChooseReleaseTypeNoAuthPage: FC = () => {
  const navigate = useNavigate()
  const { search } = useCustomSearchParams()

  const onReleasedClick = (): void => {
    navigate(`${PublicRoutesEnum.CreateSpotifyCampaign}?${search.toString()}`)
  }

  const onNotReleasedClick = (): void => {
    navigate(
      `${PublicRoutesEnum.CreatePreReleaseTrackDetails}?${search.toString()}`,
    )
  }

  return (
    <NoAuthPageLayout>
      <HelmetTitle />
      <Container>
        <CreateCampaignBreadcrumbsNoAuth
          platform={CampaignPlatformTypeEnum.SPOTIFY}
        />
        <ReleaseTypesContainer>
          <ReleaseTypeItem
            title='My track is already released'
            description='Pitch your released track to playlist curators. Get feedback and secure playlist placements.'
            onClick={onReleasedClick}
          />
          <ReleaseTypeItem
            title='My track is NOT released yet'
            description='Pitch your upcoming release to playlist curators in advance. Get early feedback and secure placements for release day.'
            onClick={onNotReleasedClick}
          />
        </ReleaseTypesContainer>
      </Container>
    </NoAuthPageLayout>
  )
}
